import { instance } from '@/services/cc/rdpFile';

export const addDataSource = (param) => instance.post('datasource/add', param);
export const updateAccountAndPassword = (param) => instance.post('datasource/updateaccountandpassword', param);
